import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useSMLCountryParam } from './useSMLCountryParam';

interface UsePlaylistsTopByFollowersProps {
  page: number;
  limit?: number;
  date?: Date;
}

export const usePlaylistsTopByFollowers = ({ page, limit = 10, date }: UsePlaylistsTopByFollowersProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const { countryCode } = useSMLCountryParam();
  const offset = (page - 1) * limit;

  const query = useTRPCQuery(
    trpcMusicAPI.playlists.topByFollowers.queryOptions({ date, offset, limit, countryCode }, { enabled: true })
  );

  return query;
};
